<div class="modal-header bg-dark text-white">
  <h4 class="modal-title pull-left">{{title}}</h4>
  <button type="button" class="close pull-right text-white" aria-label="Close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-group row">
    <label class="col-sm-3 col-form-label">Lehrgang</label>
    <div class="col-sm-9">
      <select class="form-control" [(ngModel)]="selectedForm">
        <option [ngValue]="null">- Bitte Formular auswählen -</option>
        <option [ngValue]="item" *ngFor="let item of forms">{{item.name}}</option>
      </select>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="create()">Anlegen</button>
  <button type="button" class="btn btn-danger" (click)="bsModalRef.hide()">{{closeBtnName}}</button>
</div>